import { render, staticRenderFns } from "./AF.vue?vue&type=template&id=65f5a364&"
import script from "./AF.vue?vue&type=script&lang=js&"
export * from "./AF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f5a364')) {
      api.createRecord('65f5a364', component.options)
    } else {
      api.reload('65f5a364', component.options)
    }
    module.hot.accept("./AF.vue?vue&type=template&id=65f5a364&", function () {
      api.rerender('65f5a364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61221000-4/AF.vue"
export default component.exports